import ExceptionWords from "./exception-words";

export default ExceptionWords;